export const FLOATING_SIDEBAR_TOUR_ID = 'floating-sidebar';
export const COMMENT_ONBOARDING_TOUR_ID = 'comment-onboarding';